export class TextureCoordinate {
    public u: number;
    public v: number;

    constructor(u?: number, v?: number) {
        this.u = u;
        this.v = v;
    }
}
